import { Form, Radio } from "antd";
import { cn } from "../../../../utils/global.utils";

interface OfferTypeSelectProps {
  disabled?: boolean;
}

const OfferTypeSelect = ({ disabled }: OfferTypeSelectProps) => {
  const offerTypes = [
    // {
    //   value: "Campaign",
    //   label: "Discount",
    //   description: "Offer percentage or amount off on courses",
    //   icon: (
    //     <svg
    //       width="20"
    //       height="20"
    //       viewBox="0 0 20 20"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <g clip-path="url(#clip0_1973_61644)">
    //         <path
    //           d="M10.4877 2.1563C10.1752 1.84372 9.75134 1.66806 9.30935 1.66797H3.33268C2.89065 1.66797 2.46673 1.84356 2.15417 2.15612C1.84161 2.46868 1.66602 2.89261 1.66602 3.33464V9.3113C1.66611 9.75329 1.84177 10.1771 2.15435 10.4896L9.40768 17.743C9.78644 18.1193 10.2987 18.3306 10.8327 18.3306C11.3666 18.3306 11.8789 18.1193 12.2577 17.743L17.741 12.2596C18.1174 11.8809 18.3286 11.3686 18.3286 10.8346C18.3286 10.3007 18.1174 9.7884 17.741 9.40964L10.4877 2.1563Z"
    //           stroke="currentColor"
    //           strokeWidth="1.66667"
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //         />
    //         <path
    //           d="M6.25065 6.66536C6.48077 6.66536 6.66732 6.47882 6.66732 6.2487C6.66732 6.01858 6.48077 5.83203 6.25065 5.83203C6.02053 5.83203 5.83398 6.01858 5.83398 6.2487C5.83398 6.47882 6.02053 6.66536 6.25065 6.66536Z"
    //           fill="currentColor"
    //           stroke="currentColor"
    //           strokeWidth="1.66667"
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //         />
    //       </g>
    //       <defs>
    //         <clipPath id="clip0_1973_61644">
    //           <rect width="20" height="20" fill="white" />
    //         </clipPath>
    //       </defs>
    //     </svg>
    //   ),
    //   color: "text-[#155DFC] bg-[#DBEAFE]",
    // },
    {
      value: "Coupon",
      label: "Voucher (Promo Code)",
      description: "Create a promo code for users to redeem",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.6667 6.66797H3.33333C2.8731 6.66797 2.5 7.04106 2.5 7.5013V9.16797C2.5 9.62821 2.8731 10.0013 3.33333 10.0013H16.6667C17.1269 10.0013 17.5 9.62821 17.5 9.16797V7.5013C17.5 7.04106 17.1269 6.66797 16.6667 6.66797Z"
            stroke="currentColor"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 6.66797V17.5013"
            stroke="currentColor"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.8327 10V15.8333C15.8327 16.2754 15.6571 16.6993 15.3445 17.0118C15.032 17.3244 14.608 17.5 14.166 17.5H5.83268C5.39065 17.5 4.96673 17.3244 4.65417 17.0118C4.34161 16.6993 4.16602 16.2754 4.16602 15.8333V10"
            stroke="currentColor"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.24935 6.66703C5.69681 6.66703 5.16691 6.44754 4.77621 6.05684C4.38551 5.66614 4.16602 5.13623 4.16602 4.5837C4.16602 4.03116 4.38551 3.50126 4.77621 3.11056C5.16691 2.71986 5.69681 2.50036 6.24935 2.50036C7.05325 2.48636 7.84104 2.87641 8.50996 3.61966C9.17889 4.36292 9.69791 5.42487 9.99935 6.66703C10.3008 5.42487 10.8198 4.36292 11.4887 3.61966C12.1577 2.87641 12.9454 2.48636 13.7493 2.50036C14.3019 2.50036 14.8318 2.71986 15.2225 3.11056C15.6132 3.50126 15.8327 4.03116 15.8327 4.5837C15.8327 5.13623 15.6132 5.66614 15.2225 6.05684C14.8318 6.44754 14.3019 6.66703 13.7493 6.66703"
            stroke="currentColor"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      color: "text-[#9810FA] bg-[#F3E8FF]",
    },
    // {
    //   value: "Bundle",
    //   label: "Bundle Offer",
    //   description: "Offer multiple courses together at a discount",
    //   icon: (
    //     <svg
    //       width="24"
    //       height="24"
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <path
    //         d="M12 3L2 8L12 13L22 8L12 3Z"
    //         stroke="currentColor"
    //         strokeWidth="1.5"
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //       />
    //       <path
    //         d="M2 13L12 18L22 13"
    //         stroke="currentColor"
    //         strokeWidth="1.5"
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //       />
    //       <path
    //         d="M2 18L12 23L22 18"
    //         stroke="currentColor"
    //         strokeWidth="1.5"
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //       />
    //     </svg>
    //   ),
    //   color: "text-green-500 bg-green-50",
    // },
    // {
    //   value: "BOGO",
    //   label: "BOGO (Buy One Get One)",
    //   description: "Buy one course, get another free",
    //   icon: (
    //     <svg
    //       width="24"
    //       height="24"
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <path
    //         d="M13 3L4 14H11L10 21L20 10H12L13 3Z"
    //         stroke="currentColor"
    //         strokeWidth="1.5"
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //       />
    //     </svg>
    //   ),
    //   color: "text-orange-500 bg-orange-50",
    // },
  ];

  return (
    <div className="p-6 bg-white rounded-lg border border-gray-100 shadow-sm mt-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        Select Offer Type
      </h3>

      <Form.Item name="offerType" className="mb-0 offer-type">
        <Radio.Group className="w-full flex flex-col gap-3" disabled={disabled}>
          {offerTypes.map((type) => (
            <Radio
              key={type.value}
              value={type.value}
              className={cn(
                "w-full border border-gray-200 rounded-lg p-4 transition-all hover:border-blue-500 [&.ant-radio-wrapper-checked]:border-orange-500 [&.ant-radio-wrapper-checked]:bg-orange-50/10",
                "custom-radio-card flex items-center",
              )}
            >
              <div className="flex items-center gap-4 ml-2">
                <div
                  className={cn(
                    "w-10 h-10 rounded-lg flex items-center justify-center",
                    type.color,
                  )}
                >
                  {type.icon}
                </div>
                <div>
                  <h4 className="font-medium text-gray-900">{type.label}</h4>
                  <p className="text-sm text-gray-500">{type.description}</p>
                </div>
              </div>
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>
    </div>
  );
};

export default OfferTypeSelect;
